<template>
  <div class="aboutUs">
    <div class="title">
      <van-nav-bar title=""
                   left-arrow
                   @click-left="onClickLeft" />
    </div>

    <div class="appInfo">
      <img src="../../icons/logo.png"
           alt="">
      <div>版本号：V{{ version }}</div>
    </div>

    <!-- <div class="bottomTip">
      <div>服务热线：234-224545453</div>
      <div>版权所有</div>
    </div> -->
    <div class="bottomTip">
      <div>武汉宜贰叁科技有限公司</div>
      <div>宜贰叁互联网医院</div>
      <div>版权所有</div>
    </div>
  </div>
</template>
<script>
import { toast } from '../../components/Toast'
import { getCookie } from '@/utils/auth'

export default {
  components: {},
  data () {
    return {
      version: getCookie('native_version')
    }
  },
  created () {

  },
  methods: {
    onClickLeft () {
      window.location.href = 'protocol://action/finish'
    }
  }
}
</script>
<style scoped>
@import '../../styles/search.css';
#app {
  height: 100vh;
}
.title {
  height: 64px;
}
.aboutUs /deep/.van-nav-bar {
  height: 64px;
  line-height: 64px;
}
.aboutUs .van-hairline--bottom::after {
  border: none;
}
.aboutUs {
  width: 375px;
  height: 100vh;
  background: #fff;
  position: relative;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.appInfo {
  width: 100%;
  text-align: center;
  position: fixed;
  top: 30%;
  font-size: 12px;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
}
.appInfo img {
  display: inline-block;
  width: 180px;
  height: 62px;
  /* border-radius: 5px; */
}

.bottomTip {
  width: 100%;
  position: fixed;
  bottom: 50px;
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  color: #999;
}
</style>
